import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import BrandingWatermarkOutlinedIcon from '@mui/icons-material/BrandingWatermarkOutlined';
import CableOutlinedIcon from '@mui/icons-material/CableOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';

import type { Permissions } from '../auth/usePermissions';

import type { NavigationGroup } from './NavigationItem';

/** Each item is visible when the user holds the permission its screen's first request needs. */
export const businessNavigation = (permissions: Permissions): Array<NavigationGroup> => [
  {
    heading: null,
    items: [{ path: '/', label: 'nav.overview', icon: SpaceDashboardOutlinedIcon, visible: true }],
  },
  {
    heading: 'nav.stock',
    items: [
      {
        path: '/products',
        label: 'nav.products',
        icon: Inventory2OutlinedIcon,
        visible: permissions.canAnywhere('products.read'),
      },
      {
        path: '/categories',
        label: 'nav.categories',
        icon: AccountTreeOutlinedIcon,
        visible: permissions.canAnywhere('products.read'),
      },
      {
        path: '/brands',
        label: 'nav.brands',
        icon: BrandingWatermarkOutlinedIcon,
        visible: permissions.canAnywhere('products.read'),
      },
      {
        path: '/tags',
        label: 'nav.tags',
        icon: LocalOfferOutlinedIcon,
        visible: permissions.canAnywhere('products.read'),
      },
      {
        path: '/features',
        label: 'nav.features',
        icon: FactCheckOutlinedIcon,
        visible: permissions.canAnywhere('products.read'),
      },
      {
        path: '/option-groups',
        label: 'nav.optionGroups',
        icon: TuneOutlinedIcon,
        visible: permissions.canAnywhere('products.read'),
      },
      {
        path: '/movements',
        label: 'nav.movements',
        icon: SwapVertOutlinedIcon,
        visible: permissions.canAnywhere('stock.read'),
      },
      {
        path: '/orders',
        label: 'nav.orders',
        icon: LocalShippingOutlinedIcon,
        visible: permissions.canAnywhere('orders.read'),
      },
      {
        path: '/integrations',
        label: 'nav.integrations',
        icon: CableOutlinedIcon,
        visible: permissions.canAnywhere('integrations.read'),
      },
      {
        path: '/transfers',
        label: 'nav.transfers',
        icon: SyncAltOutlinedIcon,
        visible: permissions.canAnywhere('transfers.manage'),
      },
    ],
  },
  {
    heading: 'nav.administration',
    items: [
      { path: '/companies', label: 'nav.companies', icon: ApartmentOutlinedIcon, visible: true },
      {
        path: '/contacts',
        label: 'nav.contacts',
        icon: ContactsOutlinedIcon,
        visible: permissions.canAnywhere('contacts.read'),
      },
      { path: '/users', label: 'nav.users', icon: PeopleOutlineIcon, visible: permissions.can('users.read') },
      {
        path: '/billing',
        label: 'nav.billing',
        icon: ReceiptLongOutlinedIcon,
        visible: permissions.can('billing.read'),
      },
      {
        path: '/settings/languages',
        label: 'nav.contentLanguages',
        icon: TranslateOutlinedIcon,
        visible: true,
      },
    ],
  },
];
